import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';
import mutator from 'mutator';
import qs from 'qs';
import { query } from './get-infos';

export default graphql(
  gql`
    mutation DeleteInfo($id: Int!) {
      deleteInfo(id: $id)
    }
  `,
  {
    props: ({ mutate }) => ({
      deleteInfo: async (id) => {
        return mutator(() =>
          mutate({
            variables: { id },
            update: (proxy, { data: { deleteInfo } }) => {
              const search = qs.parse(window.location.search, {
                ignoreQueryPrefix: true,
              });

              if (!deleteInfo) {
                return;
              }

              const data = proxy.readQuery({
                query,
                variables: { input: search },
              });

              proxy.writeQuery({
                query,
                variables: { input: search },
                data: {
                  ...data,
                  getInfos: {
                    ...data.getInfos,
                    count: data.getInfos.count - 1,
                    results: data.getInfos.results.filter(
                      (info) => info.id !== id
                    ),
                  },
                },
              });
            },
          })
        );
      },
    }),
  }
);
